import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-mp3-file-icon',
  templateUrl: './doc-format-mp3-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatMp3FileIconComponent {}
